const ROOT_DOMAIN = 'atrux.ro';
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);
const PUBLIC_HOSTS = new Set(['ecmr.atrux.ro', 'atrux-1cccf.web.app']);
const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export class TenantResolutionError extends Error {
  constructor(message) {
    super(message);
    this.name = 'TenantResolutionError';
  }
}

export function normalizeTenantSlug(value) {
  const slug = String(value || '').trim().toLowerCase();

  if (!SLUG_PATTERN.test(slug)) {
    throw new TenantResolutionError('Tenant slug invalid');
  }

  return slug;
}

export function normalizeHostname(hostname) {
  return String(hostname || '').trim().toLowerCase().replace(/\.$/, '');
}

export function isLocalHostname(hostname) {
  return LOCAL_HOSTS.has(normalizeHostname(hostname));
}

export function isPublicFrontendHostname(hostname) {
  return PUBLIC_HOSTS.has(normalizeHostname(hostname));
}

export function resolveTenantSlug(
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  localOverride = process.env.REACT_APP_TENANT_SLUG
) {
  const host = normalizeHostname(hostname);

  if (LOCAL_HOSTS.has(host)) {
    if (!localOverride) {
      throw new TenantResolutionError(
        'REACT_APP_TENANT_SLUG este obligatoriu pentru dezvoltarea locală'
      );
    }
    return normalizeTenantSlug(localOverride);
  }

  const suffix = `.${ROOT_DOMAIN}`;
  if (!host.endsWith(suffix)) {
    throw new TenantResolutionError('Hostname-ul nu aparține domeniului atrux.ro');
  }

  const slug = host.slice(0, -suffix.length);
  if (slug.includes('.')) {
    throw new TenantResolutionError('Se acceptă un singur nivel de subdomeniu');
  }

  if (PUBLIC_HOSTS.has(host)) {
    throw new TenantResolutionError('Hostname-ul este rezervat rutelor publice');
  }

  return normalizeTenantSlug(slug);
}

export function getTenantSlug() {
  return resolveTenantSlug();
}

export function tryResolveTenantSlug() {
  try {
    return resolveTenantSlug();
  } catch {
    return null;
  }
}

